module.exports = __webpack_public_path__ + "img/file-certificate.1414ce0.svg";